export default __webpack_public_path__ + "static/media/AppStore.ae031a36.png";